import { getVisibleBounds } from '../Utilities';
import { HomePage } from 'src/app/home/home.page';
import { GlobalService } from 'src/app/services/global.service';

export class SettingsButton {
  label: string;
  button: Phaser.GameObjects.Image;
  callback: Function;
  scene: Phaser.Scene;
  lowerOffset: number;

  constructor(scene: Phaser.Scene) {
    this.scene = scene;
    this.lowerOffset = 50;
    this.button = scene.add
      .image(
        window.innerWidth/2,
        window.innerHeight - this.lowerOffset,
        'settings_icon'
      )
      .setDepth(3)
      .setAlpha(0.65)
      .setScale(GlobalService.zoom)
      .on('pointerdown', async () => {
        GlobalService.$activeScenes.next(this.scene.scene.manager.getScenes(true));
        GlobalService.incrementModalCount();
        await HomePage.openSettingsModal();
      });
    this.button.setInteractive();
    this.button.setScrollFactor(0);
  }

    // Update the position of the button for window resize events.
    public updatePosition() {
      if(this.button){
        this.button.setPosition(window.innerWidth/2, window.innerHeight-this.lowerOffset);
      }
    }
}
